import { render, staticRenderFns } from "./JLYPieChart.vue?vue&type=template&id=36b610aa&scoped=true"
import script from "./JLYPieChart.vue?vue&type=script&lang=js"
export * from "./JLYPieChart.vue?vue&type=script&lang=js"
import style0 from "./JLYPieChart.vue?vue&type=style&index=0&id=36b610aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b610aa",
  null
  
)

export default component.exports